import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../context/Context.Language";
import ContextRenderChangeLanguage from "../../context/render/Context.RenderChangeLanguage";
import { initAuth } from "../../redux/auth.reducer";
import {
  CONSTANT_LANGUAGE,
  CONSTANT_LANGUAGE_FULL,
  TEXT_ABOUT_US,
  TEXT_ADDRESS,
  TEXT_ADDRESSES,
  TEXT_ARE_YOU_SURE_LOGOUT,
  TEXT_CANCEL,
  TEXT_CONFIRM,
  TEXT_CONTACT_US,
  TEXT_DELETE,
  TEXT_FAQ,
  TEXT_GLOSSARY,
  TEXT_LOG_IN,
  TEXT_LOG_OUT,
  TEXT_MORE,
  TEXT_MYORDER,
  TEXT_MY_PROFILE,
  TEXT_PAYMENT,
  TEXT_PRICING,
  TEXT_PRICING_SERVICE,
} from "../../utils/useConstants";
import { STATE_CONSTANTS_ADDRESS } from "../../utils/useConstantState";
import { OnClickLogout } from "../../utils/useFunction";
import {
  ICON_CONTACT_US,
  ICON_CONTACT_US_BLUE,
  ICON_DISCOUNT,
  ICON_DOCUMENT_BLUE,
  ICON_FAQ_BLUE,
  ICON_LOCATION,
  ICON_LOGIN,
  ICON_LOGOUT,
  ICON_LOGOUT_GRAY,
  ICON_MORE,
  ICON_MORE_SQUARE,
  ICON_PAYMENT_BLUE,
  ICON_PROFILE_BLUE,
  ICON_X,
} from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  StoreIsShowAnotherValue,
  StoreSelectedLocation,
  StoreTabAddress,
  SystemStoreBasketAddress,
  SystemStoreStar,
} from "../../utils/useStorage";
import {
  STYLE_ARROW_RED,
  STYLE_BODY_3_REGULAR,
  STYLE_BORDER_BOTTOM_MENU,
  STYLE_HEADING_3,
  STYLE_HEADING_3_BOLD_24_18,
  STYLE_HEADING_3_BOLD_24_18_TH,
  STYLE_HEADING_3_TH,
  STYLE_HOVER_BLUE,
  STYLE_ICON_DRAWER,
  STYLE_NAVBAR_LOGO,
  STYLE_PARENT_DELETE_PROGRAM,
  STYLE_PARENT_MENU,
  STYLE_PARENT_PANEL_MODAL,
  STYLE_TITLE_MENU,
} from "../../utils/useStyle";
import TemplateModal from "../template/Template.Modal";
import BasketOnClickEditAddress from "../../pages/basket/function/Basket.OnClickEditAddress";
import { FunctionCheckIsTH } from "../../pages/task/functions/Program.ClickBack";

const Language = () => {
  return (
    <div className={`${STYLE_PARENT_MENU} h-6`}>
      <ContextRenderChangeLanguage text={true} drawer={true} />
    </div>
  );
};

const Login = ({ language, login, open, setOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [openLogout, setOpenLogout] = React.useState(false);
  const { user } = useSelector((state) => state.auth);
  return (
    <div>
      <div
        onClick={() => {
          if (login) {
            setOpenLogout(true);
          } else {
            sessionStorage.setItem("redirect", location.pathname);
            navigate("/Login");
            setOpen(!open);
          }
        }}
        className={` ${user?._id ? "ml-2px " : "ml-1px "} flex ${
          user?._id ? " gap-[11px] " : " gap-[10px] "
        } items-center  hover:text-laundry-primary-blue group w-fit`}
      >
        {user?._id ? (
          <React.Fragment>
            <ICON_LOGOUT_GRAY
              className={` group-hover:text-laundry-primary-blue text-laundry-gray-100 w-[20px] h-[20px] `}
              className_arrow={STYLE_ARROW_RED}
            />
            <div className={STYLE_TITLE_MENU(language)}>
              {TEXT_LOG_OUT[language]}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <ICON_LOGIN
              className={`w-[22px] h-[22px]`}
              // onClick={() => {
              //   navigate("/Login");
              //   setOpen(!open);
              // }}
            />
            <div className={STYLE_TITLE_MENU(language)}>
              {TEXT_LOG_IN[language]}
            </div>
          </React.Fragment>
        )}
      </div>
      {openLogout && (
        // <TemplateModal
        //   classNameModal={`${
        //     language === "TH" ? "font-NotoSansThai" : "font-Poppins"
        //   } w-modals_mb_logout h-h_156 md:h-h_220 md:w-modals`}
        // acceptText={TEXT_LOG_OUT[language]}
        // cancelText={TEXT_CANCEL[language]}
        // save={() => {
        //   OnClickLogout(dispatch, navigate, location);
        // }}
        // showCloseButton={true}
        // showSaveButton={true}
        // open={openLogout}
        //   setOpen={setOpenLogout}
        //   panel={
        //     <div
        //       className={`${STYLE_PARENT_PANEL_MODAL} ${
        //         language === "TH" ? "font-NotoSansThai" : "font-Poppins"
        //       }`}
        //     >
        //       <div
        //         className={`${
        //           language === "TH" ? STYLE_HEADING_3_TH : STYLE_HEADING_3
        //         } text-center  md:h-head_language  `}
        //       >
        //         {TEXT_LOG_OUT[language]}?
        //       </div>
        //       <div
        //         className={` md:pt-4 pb-2.5 h-6 md:h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
        //           language
        //         )}`}
        //       >
        //         {TEXT_ARE_YOU_SURE_LOGOUT[language]}
        //       </div>
        //     </div>
        //   }
        // />
        <TemplateModal
          acceptText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_LOG_OUT[language]}
            </div>
          }
          cancelText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_CANCEL[language]}
            </div>
          }
          save={() => {
            OnClickLogout(dispatch, navigate, location);
          }}
          showCloseButton={true}
          showSaveButton={true}
          open={openLogout}
          setOpen={setOpenLogout}
          panel={
            <div
              className={`${STYLE_PARENT_DELETE_PROGRAM} ${
                language === "TH" ? "font-NotoSansThai" : "font-Poppins"
              }  `}
            >
              <div
                className={`${
                  language === "TH"
                    ? STYLE_HEADING_3_BOLD_24_18_TH
                    : STYLE_HEADING_3_BOLD_24_18
                } text-center h-h_30 `}
              >
                {TEXT_LOG_OUT[language]}?
              </div>
              <div
                className={` py-3 md:pt-6 h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                  language
                )}`}
              >
                {TEXT_ARE_YOU_SURE_LOGOUT[language]}
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};

const DrawerMain = ({ open, setOpen, openLogout, setOpenLogout }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [open]);

  const { user } = useSelector((state) => state.auth);

  const Menu = [
    {
      icon: <ICON_DOCUMENT_BLUE className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_MYORDER[language]}`,
      path: "/MyOrders",
    },
    {
      icon: <ICON_PROFILE_BLUE className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_MY_PROFILE[language]}`,
      path: "/MyProfile",
    },
    {
      icon: <ICON_LOCATION className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_ADDRESSES[language]}`,
      path: "/Address",
    },
    // {
    //   icon: <ICON_PAYMENT_BLUE />,
    //   title: `${TEXT_PAYMENT[language]}`,
    //   path: "/Payment",
    // },
    {
      icon: <ICON_DISCOUNT className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_PRICING[language]}`,
      path: "/Pricing",
    },
    {
      icon: <ICON_FAQ_BLUE className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_FAQ[language]}`,
      path: "/FAQ",
    },
    // {
    //   icon: <ICON_MORE_SQUARE className={STYLE_ICON_DRAWER} />,
    //   title: `${TEXT_GLOSSARY[language]}`,
    //   path: "/Glossary",
    // },
    {
      icon: <ICON_CONTACT_US className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_ABOUT_US[language]}`,
      path: "/AboutUs",
    },
    {
      icon: <ICON_CONTACT_US_BLUE className={STYLE_ICON_DRAWER} />,
      title: `${TEXT_CONTACT_US[language]}`,
      path: "/ContactUs",
    },
    // {
    //   icon: <ICON_MORE className="w-6 mx-auto" />,
    //   title: `${TEXT_MORE[language]}`,
    //   path: "/More",
    // },
  ];

  const location = useLocation();

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );
  const address = SystemStoreBasketAddress((state) => state.address);
  const setStar = SystemStoreStar((state) => state.setStar);

  // const setTab = StoreTabAddress((state) => state.setTab);
  // const tab = StoreTabAddress((state) => state.tab);
  // const setIsShowAnother = StoreIsShowAnotherValue(
  //   (state) => state.setIsShowAnother
  // );
  // const setSelectedLocation = StoreSelectedLocation(
  //   (state) => state.setSelectedLocation
  // );

  return (
    <div
      onClick={() => {
        setOpen(false);
      }}
      className={`${
        open ? "bg-opacity-40 z-30 " : "bg-opacity-0 z-0 w-0 h-0"
      }  bg-black fixed inset-0 duration-500 `}
    >
      <div
        // className="bg-laundry-primary-blue-10 h-screen w-72 absolute top-0  left-0 p-6 flex flex-col justify-between"
        className={` ${
          open
            ? " bg-laundry-primary-blue-10  w-full md:w-[208px] lg:w-[278px] xl:w-[332px] px-6 md:py-7 md:px-6 "
            : "  w-0 p-0 "
        }  top-0 left-0  h-full flex-1`}
        onClick={(e) => e.stopPropagation()}
      >
        {open && (
          <div className=" flex flex-col justify-between h-full overflow-y-scroll">
            <div className=" ">
              {isMobile ? (
                <div className="">
                  <div className=" h-16  flex flex-col justify-end">
                    <ICON_X
                      className=" w-11 text-laundry-gray-100 -ml-2 "
                      onClick={() => {
                        setOpen(false);
                      }}
                    />
                  </div>
                  <img
                    src="/images/logo.png"
                    className=" h-h_38 mx-0 my-4 md:m-4 mb-8"
                    onClick={() => {
                      navigate(`/`);
                      setOpen(false);
                    }}
                  />
                </div>
              ) : (
                ""
              )}
              {Menu?.map((row, index) => {
                return (
                  <div key={index} className="">
                    <div
                      onClick={() => {
                        if (
                          location?.pathname === "/Address" &&
                          row?.path === "Address"
                        ) {
                          setOpen(false);
                          return;
                        } else if (address && row?.path === "/Address") {
                          BasketOnClickEditAddress({
                            user,
                            address,
                            setStar,
                            navigate,
                            setSelectedLocation,
                          });
                          setOpen(!open);
                        } else {
                          navigate(`${row?.path}`) || setOpen(!open);
                        }
                      }}
                      className={`${STYLE_PARENT_MENU} ${
                        row?.title === "ออเดอร์ของฉัน"
                          ? " w-[100%] "
                          : " w-[60%] "
                      } h-6 `}
                    >
                      <div
                      // onClick={() => {
                      //   if (
                      //     location?.pathname === "/Address" &&
                      //     row?.path === "Address"
                      //   ) {
                      //     setOpen(false);
                      //     return;
                      //   } else if (address && row?.path === "/Address") {
                      //     BasketOnClickEditAddress({
                      //       user,
                      //       address,
                      //       setStar,
                      //       navigate,
                      //       setSelectedLocation,
                      //     });
                      //     setOpen(!open);
                      //   } else {
                      //     // const x = FunctionCheckIsTH(row?.path);
                      //     // console.log("X", {
                      //     //   x,
                      //     //   row,
                      //     // });
                      //     // if (x) {
                      //     //   navigate(`${row?.path}/TH`) || setOpen(!open);
                      //     // } else {
                      //     //   navigate(`${row?.path}`) || setOpen(!open);
                      //     // }
                      //     navigate(`${row?.path}`) || setOpen(!open);
                      //   }
                      // }}
                      >
                        {row?.icon}
                      </div>
                      <div
                        // onClick={() => {
                        //   if (
                        //     location?.pathname === "/Address" &&
                        //     row?.path === "/Address"
                        //   ) {
                        //     setOpen(false);

                        //     return;
                        //   } else if (address && row?.path === "/Address") {
                        //     BasketOnClickEditAddress({
                        //       user,
                        //       address,
                        //       setStar,
                        //       navigate,
                        //       setSelectedLocation,
                        //     });
                        //     setOpen(!open);
                        //   } else {
                        //     // const x = FunctionCheckIsTH(row?.path);
                        //     // console.log("X", {
                        //     //   x,
                        //     //   row,
                        //     // });
                        //     // if (x) {
                        //     //   navigate(`${row?.path}/TH`) || setOpen(!open);
                        //     // } else {
                        //     //   navigate(`${row?.path}`) || setOpen(!open);
                        //     // }
                        //     navigate(`${row?.path}`) || setOpen(!open);
                        //   }
                        // }}
                        className={`${
                          language === "TH"
                            ? " text-sm-th md:text-base-th "
                            : " text-sm md:text-base "
                        }  cursor-pointer text-laundry-gray-100 hover:text-laundry-primary-blue`}
                      >
                        {row?.title}
                      </div>
                    </div>
                    <div
                      className={
                        index + 1 < Menu?.length && STYLE_BORDER_BOTTOM_MENU
                      }
                    ></div>
                  </div>
                );
              })}
            </div>
            <div className=" mb-6 md:mb-0 ">
              <Language language={language} drawer={true} />
              <div className=" pt-[18px] ">
                <Login
                  language={language}
                  login={user?._id}
                  openLogout={openLogout}
                  setOpenLogout={setOpenLogout}
                  open={open}
                  setOpen={setOpen}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default DrawerMain;
